import { useToast } from '@/hooks/use-toast';
import { useUpdateCampaignStatus } from '../hooks/use-campaigns';
import { useApolloClient } from '@apollo/client';
import { GET_CAMPAIGNS } from '../../../queries/campaigns';
import { ActionDialog } from './action-dialog';
import { CampaignStatus } from '@/gql/graphql';

interface ResumeCampaignDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  campaignId: string;
  campaignName: string;
}

export function ResumeCampaignDialog({
  open,
  onOpenChange,
  campaignId,
  campaignName
}: ResumeCampaignDialogProps) {
  const { toast } = useToast();
  const { update, loading } = useUpdateCampaignStatus();
  const client = useApolloClient();

  const handleResume = async () => {
    try {
      await update(campaignId, CampaignStatus.Sending);
      // Force refetch campaigns
      await client.refetchQueries({
        include: [GET_CAMPAIGNS]
      });
      toast({
        title: 'Success',
        description: 'Campaign resumed successfully.'
      });
      onOpenChange(false);
    } catch (_error) {
      toast({
        title: 'Error',
        description: 'Failed to resume campaign. Please try again.',
        variant: 'destructive'
      });
    }
  };

  return (
    <ActionDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Resume Campaign"
      description={`Are you sure you want to resume the campaign "${campaignName}"?`}
      actionLabel="Resume Campaign"
      loadingLabel="Resuming..."
      onAction={handleResume}
      loading={loading}
    />
  );
}
